module.exports = __webpack_public_path__ + "static/img/examineRX.f5d16a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examineRX.png
// module id = 27el
// module chunks = 5